import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "space-y-6 pb-8 px-4" }
const _hoisted_3 = { class: "flex flex-row w-8/12" }
const _hoisted_4 = { class: "flex flex-row w-8/12" }
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_6 = { class: "space-y-2 pt-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "text-12px font-normal text-gray-lp-500 max-w-md" }, " Lokasi dengan status Free Trade Zone yang aktif merupakan kawasan perdagangan bebas. ", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_9 = { class: "space-y-2 pt-2" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "text-12px font-normal text-gray-lp-500 max-w-md" }, " Rute dengan status yang aktif akan digunakan sebagai lokasi awal atau destinasi pada modul route mapping ", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_12 = { class: "space-y-2 pt-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "text-12px font-normal text-gray-lp-500 max-w-md" }, " Klik tombol dibawah jika ingin mengaktifkan sunday delivery ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : _createCommentVNode("", true),
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      customClass: "px-0",
      onBack: _ctx.goBack,
      title: " Edit Lokasi",
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.fetchCityData
    }, _createSlots({
      data: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataWrapper, {
            label: "City Code",
            class: "w-8/12"
          }, {
            default: _withCtx(() => [
              _createVNode("input", {
                type: "text",
                placeholder: "REM",
                class: 
              `py-1.5 xxl:py-2 px-4 opacity-50 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                'bg-white'}`
            ,
                value: _ctx.dataDetail().code,
                disabled: _ctx.isDisabled
              }, null, 10, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              label: "Nama Lokasi",
              class: "py-3 w-1/2 mr-5"
            }, {
              default: _withCtx(() => [
                _createVNode("input", {
                  type: "text",
                  placeholder: "Rembang",
                  class: 
                `py-1.5 xxl:py-2 px-4 opacity-50 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                  value: _ctx.dataDetail().name,
                  disabled: _ctx.isDisabled
                }, null, 10, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "py-3 w-1/2",
              label: "Timezone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Select, {
                  dataSelect: _ctx.statusData,
                  onOpenSelect: _ctx.onOpenStatusSelect,
                  onCloseSelect: _ctx.onCloseStatusSelect,
                  onChooseSelect: _ctx.onSelectStatus,
                  value: _ctx.statusName,
                  isOpenMenu: _ctx.statusSelect,
                  class: "w-full opacity-50",
                  isDisabled: _ctx.isDisabled
                }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu", "isDisabled"])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_DataWrapper, {
              class: "py-3 w-1/2 mr-4",
              label: "Origin Transit"
            }, {
              default: _withCtx(() => [
                _createVNode("input", {
                  type: "text",
                  placeholder: "",
                  class: 
                `py-1.5 xxl:py-2 px-4 opacity-50 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                  value: _ctx.dataDetail().originTransit,
                  disabled: _ctx.isDisabled
                }, null, 10, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "py-3 w-1/2 mr-2",
              label: "Destination Transit"
            }, {
              default: _withCtx(() => [
                _createVNode("input", {
                  type: "text",
                  placeholder: "",
                  class: 
                `py-1.5 xxl:py-2 px-4 opacity-50 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                  value: _ctx.dataDetail().destinationTransit,
                  disabled: _ctx.isDisabled
                }, null, 10, ["value", "disabled"])
              ]),
              _: 1
            })
          ]),
          _hoisted_5,
          _createVNode(_component_DataWrapper, {
            label: "Free Trade Zone",
            class: "my-6"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Toggle, {
                  onClick: _ctx.changeFreeTradeZone,
                  modelValue: _ctx.isFreeTradeZone,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isFreeTradeZone = $event)),
                  textActive: "Aktif",
                  textInactive: "Tidak Aktif"
                }, null, 8, ["onClick", "modelValue"])
              ])
            ]),
            _: 1
          }),
          _hoisted_8,
          _createVNode(_component_DataWrapper, {
            label: "Status Rute",
            class: "my-6"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Toggle, {
                  onClick: _ctx.onOpenRoute,
                  modelValue: _ctx.isRoute,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isRoute = $event)),
                  textActive: "Rute Aktif",
                  textInactive: "Rute Tidak Aktif"
                }, null, 8, ["onClick", "modelValue"])
              ])
            ]),
            _: 1
          }),
          _hoisted_11,
          _createVNode(_component_DataWrapper, {
            label: "Sunday Delivery",
            class: "my-6"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Toggle, {
                  onClick: _ctx.changeSundayDelivery,
                  modelValue: _ctx.isSundayDelivery,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isSundayDelivery = $event)),
                  textActive: "Aktif",
                  textInactive: "Tidak Aktif"
                }, null, 8, ["onClick", "modelValue"])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      "sub-data": _withCtx(() => [
        _createVNode(_component_DataWrapper, {
          label: "Status Rute",
          value: _ctx.isRoute ? 'Active' : 'Inactive',
          customStyleValue: 
          `max-w-max rounded-full px-2 py-0 font-medium capitalize ${
            _ctx.isRoute ? 'bg-green-lp-300' : 'bg-red-lp-600'
          } ${_ctx.isRoute ? 'text-green-lp-200' : 'text-red-lp-500'}`
        
        }, null, 8, ["value", "customStyleValue"]),
        _createVNode(_component_DataWrapper, {
          label: "Tanggal Dibuat",
          value: _ctx.createdAt,
          caption: _ctx.createdBy
        }, null, 8, ["value", "caption"]),
        _createVNode(_component_DataWrapper, {
          label: "Tanggal Dibuat",
          value: _ctx.updateAt,
          caption: _ctx.updateBy
        }, null, 8, ["value", "caption"])
      ]),
      _: 2
    }, [
      (!_ctx.isError)
        ? {
            name: "top-right",
            fn: _withCtx(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_LpButton, {
                  "text-color": "white",
                  customClass: "w-full py-2.5 px-8",
                  title: "Simpan",
                  onClick: _ctx.onOpenSave
                }, null, 8, ["onClick"])
              ])
            ])
          }
        : undefined
    ]), 1032, ["onBack", "loading", "error", "errorType", "onTryAgain"]),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCloseRoute,
      onSubmit: _ctx.changeRoute,
      title: _ctx.isRoute ? 'Non-aktifkan Lokasi' : 'Aktifkan Lokasi',
      message: 
      _ctx.isRoute
        ? 'Selama lokasi berstatus non-aktif maka lokasi tidak dapat digunakan dalam “route mapping”'
        : 'Selama lokasi berstatus aktif maka lokasi dapat digunakan dalam “route mapping”'
    ,
      image: "inactive-location",
      textSuccess: _ctx.isRoute ? 'Non-aktifkan' : 'Aktifkan',
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.openRoute]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Perubahan Disimpan",
      message: `Lokasi ${_ctx.dataDetail().name} berhasil diubah`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin Keluar Halaman ?",
      message: "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Perubahan Data Lokasi",
      message: 
      `Anda yakin akan menyimpan perubahan untuk  lokasi “${
        _ctx.dataDetail().name
      } - ${_ctx.dataDetail().code}”`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8",
      isLoading: _ctx.isLoading
    }, null, 8, ["onSubmit", "onClose", "message", "isLoading"]), [
      [_vShow, _ctx.openSave()]
    ])
  ], 64))
}